import { MacroAddDxDto } from '.';
import { MacroAddProcedureDto } from './MacroAddProcedureDto';
import { MacroGroupDto } from './MacroGroupDto';

export enum MacroDataSourceEnum {
  Client = 'Client',
  Server = 'Server',
  Both = 'Both',
}

export enum MacroContextEnum {
  Patient = 'Patient',
  Visit = 'Visit',
  None = 'None',
}

export class MacroDefinitionDto {

  constructor() {
    this.SelectionIds = [];
    this.SupportedEditors = [];
    this.AddDxs = [];
    this.AddSPs = [];
    this.AddSOs = [];
  }

  Id: string | null;
  SelectionIds: string[];
  TransientUXId: string;
  Name: string | null;
  IsEnabled: boolean;
  DataSource: MacroDataSourceEnum;
  SupportedEditors: string[];
  DataPropertyPath: string;
  DataContext: MacroContextEnum;
  Description: string;
  Text: string;
  IsUserDefined: boolean;
  MacroGroup: MacroGroupDto;
  AddDxs: MacroAddDxDto[];
  AddSPs: MacroAddProcedureDto[];
  AddSOs: MacroAddProcedureDto[];
  Goal: string;
  RequiresBackendProcessing: boolean;
  PreProcessAQN: string;
  ActionAQN: string;
}
